<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <template #activator="{ on }">
        <div class="list-item">
          <v-btn
            class="list-item-btn"
            :ripple="false"
            block
            color="white"
            v-on="on"
          >
            <div class="list-item-text">
              <span class="list-item-name">{{
                testatorEmail || 'Add email address'
              }}</span>
            </div>
          </v-btn>
        </div>
      </template>

      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11">
              <h2 class="text-h5">Update your email</h2>
            </v-col>
            <v-col cols="1">
              <v-icon
                class="modal-close"
                color="black"
                @click.stop="closeDialog"
                >{{ icons.mdiClose }}</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>

        <v-divider />

        <v-card-text class="crud-card-text">
          <ValidationObserver ref="observer">
            <ValidationProvider
              id="email"
              v-slot="{ errors }"
              name="email"
              rules="required|email"
            >
              <v-text-field
                v-model.trim="email"
                label="Email"
                :error-messages="errors"
              />
            </ValidationProvider>
          </ValidationObserver>
          <p>All further correspondence will be sent to this email address.</p>
        </v-card-text>

        <v-card-actions class="crud-card-actions">
          <v-btn
            rounded
            depressed
            :loading="buttonLoading"
            color="primary"
            class="ml-4 mb-1"
            @click="save()"
            ><span>Yes, update</span
            ><v-icon small>{{ icons.mdiArrowRight }}</v-icon></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ErrorSnackbar v-model="showError" :error="errorMessage" />
    <SuccessSnackbar v-model="showSuccess" :message="successMessage" />
  </div>
</template>

<script>
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import SuccessSnackbar from '../common/SuccessSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';
  import { UPDATE_USER_MUTATION } from '../../constants/graphql/users';
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';

  export default {
    name: 'UpdateEmail',
    components: {
      ErrorSnackbar,
      SuccessSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      testatorEmail: {
        required: true,
        type: String,
      },
    },
    data() {
      return {
        dialog: false,
        email: this.testatorEmail,
        errorMessage: null,
        showSuccess: false,
        successMessage: null,
      };
    },
    watch: {
      dialog(newValue) {
        if (newValue == true) {
          this.errorMessage = null;
        }
      },
    },
    methods: {
      save() {
        this.$refs.observer.validate().then(valid => {
          if (valid) {
            this.buttonLoading = true;
            this.updateEmail();
          } else {
            const errors = this.$refs.observer.ctx.errors;
            document
              .getElementById(
                Object.keys(errors).find(field => errors[field].length)
              )
              .scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      },
      updateEmail() {
        const userInputDetails = {
          email: this.email,
        };
        const id = this.userId;

        this.$apollo
          .mutate({
            mutation: UPDATE_USER_MUTATION,
            variables: {
              id,
              userInputDetails,
            },
            update: (cache, { data: { updateUser } }) => {
              this.updateCacheAfterUpdateUser(cache, updateUser);
            },
          })
          .then(_response => {
            this.showSuccessMessage();
          })
          .catch(error => {
            if (error.message.includes('GraphQL error:')) {
              this.errorMessage = error.message
                .replace('GraphQL error:', '')
                .trim();
              this.displayErrorAndCloseDialog();
            } else {
              this.displayErrorAndCloseDialog();
              throw error;
            }
          });
      },
      updateCacheAfterUpdateUser(cache, updateUser) {
        const query = {
          query: TESTATOR_QUERY,
          variables: { id: this.testatorId },
        };
        const data = cache.readQuery(query);

        data.testator.email = updateUser.email;

        cache.writeQuery({ ...query, data });
      },
      showSuccessMessage() {
        this.successMessage = 'Your email has been updated';
        this.showSuccess = true;
        this.closeDialog();
      },
      closeDialog() {
        this.dialog = false;
        this.buttonLoading = false;
        this.email = this.testatorEmail;
        this.$refs.observer.reset();
      },
    },
  };
</script>
